import { create } from "zustand";
import { AuthenticationSlice, createAuthenticationSlice } from "./AuthenticationSlice";
import { OrganizationSlice, createOrganizationSlice } from "./OrganizationSlice";
import { PlaybooksSlice, createPlaybooksSlice } from "./PlaybooksSlice";
import { ProjectsSlice, createProjectsSlice } from "./ProjectsSlice";
import { QAgentSlice, createQAgentSlice } from "./QAgentSlice";
import { OnboardingSlice, createOnboardingSlice } from "./OnboardingSlice";
import { persist } from "zustand/middleware";

type BoundStore = AuthenticationSlice & OrganizationSlice & PlaybooksSlice & ProjectsSlice & QAgentSlice & OnboardingSlice;

export const useBoundStore = create<BoundStore>()(
  persist(
    (...a) => ({
      ...createAuthenticationSlice(...a),
      ...createOrganizationSlice(...a),
      ...createPlaybooksSlice(...a),
      ...createProjectsSlice(...a),
      ...createQAgentSlice(...a),
      ...createOnboardingSlice(...a),
    }),
    {
      name: "item-storage",
      partialize: (state) => {
        // Exclude qagentChats from persistence to avoid stale data issues, and
        // activeTourId which is transient (the server is the source of truth for
        // which tours have been seen).
        const { qagentChats, activeQAgentChat, isQAgentLoading, qagentError, activeTourId, ...rest } = state;
        return rest;
      },
    }
  )
);
